import { useEffect, useRef, useState } from 'react';
import { GrClose } from 'react-icons/gr';
import { FaInfoCircle } from 'react-icons/fa';
import useBrowserStorageState from '../../hooks/useBrowserStorageState';
import Button from '../inputs/Button';

export default function HelpfulTipsContainer({ show, incrementShownCount }) {
  const [isOpen, setIsOpen] = useState(() => (show != null ? show : false));
  const [doNotShow, setDoNotShow] = useBrowserStorageState(
    'localStorage',
    'doNotShowHelpfulTips',
    false
  );
  const [doNotShowThisSession, setDoNotShowThisSession] =
    useBrowserStorageState('sessionStorage', 'doNotShowDemoHelpfulTip', false);

  const hasIncrementedShownCountRef = useRef(null);

  useEffect(() => {
    if (!doNotShow && !doNotShowThisSession) {
      setIsOpen(show);
    }
  }, [doNotShow, doNotShowThisSession, show]);

  useEffect(() => {
    if (
      !doNotShow &&
      !doNotShowThisSession &&
      show &&
      (hasIncrementedShownCountRef.current === undefined ||
        hasIncrementedShownCountRef.current?.incrementedShownCount === false)
    ) {
      incrementShownCount();
      hasIncrementedShownCountRef.current = { hasIncrementedShown: true };
    }
  }, [doNotShow, doNotShowThisSession, incrementShownCount, show]);

  function handleDoNotShowClick() {
    setDoNotShow(true);
    setIsOpen(false);
  }

  function handleCloseClick() {
    setIsOpen(false);
    setDoNotShowThisSession(true);
  }

  function handleWatchClick() {
    setIsOpen(false);
    setDoNotShowThisSession(true);
  }

  return (
    <div
      className={`absolute bottom-4 mr-4 bg-white rounded-half shadow-md px-5 pt-5 pb-2 transition-all duration-500 ease-in-out ${
        isOpen ? 'left-4 translate-x-0' : '-left-10 -translate-x-full'
      }`}
    >
      <div className="flex justify-between mb-2">
        <div>
          <div className="flex flex-row items-center mb-2">
            <FaInfoCircle className="mr-2" />
            <div className="text-lg font-bold">Helpful Tip</div>
          </div>
          <p className="mb-4">
            Get to know the platform better to see what you can do.
          </p>
          <div className="flex space-x-1">
            <a
              href="https://www.loom.com/share/2777f53c6c2a4f3e96fb1fb41d451dd3?sid=94db5471-9e36-4f4b-94d8-0e213f83410d"
              target="_blank"
              rel="noreferrer"
            >
              <Button
                type="button"
                small
                short
                secondary
                onClick={handleWatchClick}
              >
                Watch the full platform demo here
              </Button>
            </a>
          </div>
          <button
            className="mt-6 text-xs font-bold text-blue hover:text-primary"
            onClick={handleDoNotShowClick}
          >
            Don't show helpful tips
          </button>
        </div>
        <div className="flex flex-col ml-3">
          <button
            className="text-xl text-gray-500 mb-2"
            onClick={handleCloseClick}
          >
            <GrClose />
          </button>
        </div>
      </div>
    </div>
  );
}
